import ControlFactory from '@/Factories/ControlFactory';
import AssociationBoxViewModel from '@/ViewModels/Controls/AssociationBoxViewModel';
import AssociationBox from '@/Controls/AssociationBox';
import { IRefreshable } from '#/DefaultViewExtensionInterfaces';
import AssociationBoxViewModelT from '@/ViewModels/Controls/AssociationBoxViewModel';
import TextBoxViewModelT from '@/ViewModels/Controls/TextBoxViewModel';
import HiddenViewModelT from '@/ViewModels/Controls/HiddenViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import SearchListViewViewModelT from '@/ViewModels/Views/SearchListViewViewModel';
import NavigationService from '@/Management/NavigationService';
import NavigationHelper from '@/Management/NavigationHelper';
import Config from '@/Management/GlobalConfiguration';
import ComponentManager from '@/Management/ComponentManager';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import Loader from '@/Utility/Loader';
export default class AssociationBoxFactory extends ControlFactory implements IRefreshable {
    /** @overrides */
    public control: AssociationBox;
    /** @overrides */
    public viewModel: AssociationBoxViewModel;
    public isModalCreating: any;
    public customSearchListTitle: any;
    private AssociationBoxViewModel: any;
    private AssociationBox: any;
    private ObjectConnectionHelper: any;
    private ObjectDisconnectionHelper: any;
    private ObjectDeletionHelper: any;
    private ObjectCreationHelper: any;
    private _objectHelper: any;
    private TextBoxViewModel: any;
    private HiddenViewModel: any;
    protected LabelViewModel: any;
    protected LinkViewModel: any;
    protected ImageViewModel: any;
    private SearchListViewViewModel: any;
    private objectIdentValue: any;
    private pdoId: any;
    private viewFactorySearchListView: any;
    private jQueryControl: JQuery;
    constructor(params: any) {
        super(params);
        this.jQueryControl = null;
        this.AssociationBoxViewModel = ComponentManager.getViewModel<typeof AssociationBoxViewModelT>('AssociationBoxViewModel');
        this.AssociationBox = ComponentManager.getControl('AssociationBox');
        this.ObjectConnectionHelper = ComponentManager.getUtility('ObjectConnectionHelper');
        this.ObjectDisconnectionHelper = ComponentManager.getUtility('ObjectDisconnectionHelper');
        this.ObjectDeletionHelper = ComponentManager.getUtility('ObjectDeletionHelper');
        this.ObjectCreationHelper = ComponentManager.getUtility('ObjectCreationHelper');
        this._objectHelper = null;
        this.TextBoxViewModel = ComponentManager.getViewModel<typeof TextBoxViewModelT>('TextBoxViewModel');
        this.HiddenViewModel = ComponentManager.getViewModel<typeof HiddenViewModelT>('HiddenViewModel');
        this.LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');
        this.LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
        this.ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
        this.SearchListViewViewModel = ComponentManager.getViewModel<typeof SearchListViewViewModelT>('SearchListViewViewModel');
        this.objectIdentValue = this.context.genericObject.getObservable(this.detailViewItem.name + '.ObjectIdentValue');
        this.pdoId = this.context.genericObject.getObservable(this.detailViewItem.name + '.PDO_ID');
        this.viewFactorySearchListView = null;
        this.isModalCreating = this.paramOrDefault(params.isModalCreating, false);
        this.customSearchListTitle = this.paramOrDefault(params.customSearchListTitle, '');
    }
    /** @overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.PDO_ID');
        this.context.genericObject.suppressNotificationFor(this.detailViewItem.name + '.ObjectIdentValue');
        this.viewModel = (() => {
            let associationBoxViewModel = new this.AssociationBoxViewModel({
                factory: this,
                isEnabled: this.isEnabled,
                isRequired: this.isRequired,
                isValid: this.isValid,
                tooltip: new this.LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                textBox: new this.TextBoxViewModel({
                    value: this.objectIdentValue,
                    isEnabled: false,
                    isFocusable: this.isFocusable,
                    isValid: this.isValid,
                    invalidationText: this.invalidationText,
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name
                }),
                hidden: new this.HiddenViewModel({
                    value: this.pdoId
                }),
                linkCreate: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.link.create',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.link.create.image',
                        source: Config.inlineImages.OBJ_CREATE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        if (!this.IsValidItemSelected()) {
                            $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [null] }))
                                .then((doUpdateAssociation) => {
                                    if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                        this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                    }
                                });
                        }
                        else {
                            let contextPdoId = this.context.genericObject.pdoId;
                            let associationName = this.detailViewItem.listView.relationName;
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            this._objectHelper = new this.ObjectCreationHelper({
                                contextPdoId: contextPdoId,
                                associationName: associationName,
                                pdTypeName: pdTypeName,
                                affectedObjectIds: [this.pdoId()],
                                creationCallback: () => {
                                    $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'connect', { toPdoIds: [null] }))
                                        .then((doUpdateAssociation) => {
                                            if (doUpdateAssociation == null || doUpdateAssociation === true) {
                                                this.context.createContext(this, this.detailViewItem.listView, null, null, null, null, this.isModalCreating);
                                            }
                                        });
                                },
                                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                            });
                            this._objectHelper.ExecuteCheck();
                        }
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonCreate;
                    }),
                    tooltip: new this.LabelViewModel({
                        ergName: 'CREATE_NEW_AND_CONNECT_TOOLTIP'
                    }),
                    isToolBarLink: true,
                    isFocusable: this.isFocusable,
                    isEnabled: this.isEnabled
                }),
                linkSelect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.link.select',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.link.select.image',
                        source: Config.inlineImages.OBJ_SELECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'FIND_AND_CONNECT_TOOLTIP'
                        })
                    }),
                    onClick: () => {
                        let contextId = this.context.genericObject.pdoId;
                        if (this.viewFactorySearchListView != null) {
                            return;
                        }
                        this.viewFactorySearchListView = NavigationService.getInstance().loadViewFactoryIsolated('SearchListView', {
                            viewModel: new this.SearchListViewViewModel({
                                parentLocator: this.locator,
                                locator: this.detailViewItem.name + '.selectview',
                                contextPdoId: contextId,
                                listView: this.detailViewItem.listView,
                                customTitle: this.customSearchListTitle,
                                allowMultiSelect: false,
                                callback: (toPDOIDs) => {
                                    if (toPDOIDs && toPDOIDs.length > 0) {
                                        let selPdoId = toPDOIDs[0];
                                        if (!this.IsValidItemSelected()) {
                                            this.OnConnection(selPdoId);
                                        }
                                        else {
                                            let currentItem = [this.pdoId()];
                                            let associationName = this.detailViewItem.listView.relationName;
                                            let pdTypeName = this.detailViewItem.listView.typeName;
                                            this._objectHelper = new this.ObjectConnectionHelper({
                                                contextPdoId: contextId,
                                                associationName: associationName,
                                                pdTypeName: pdTypeName,
                                                affectedObjectIds: currentItem,
                                                objectIdToConnect: selPdoId,
                                                connectionCallback: this.OnConnection.bind(this),
                                                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                                            });
                                            this._objectHelper.ExecuteCheck();
                                        }
                                    }
                                },
                                onClose: () => {
                                    associationBoxViewModel.linkSelect.hasFocus(true);
                                    NavigationService.getInstance().removeViewFactoryIsolated(this.viewFactorySearchListView);
                                    this.viewFactorySearchListView = null;
                                }
                            })
                        }, true);
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonSelect;
                    }),
                    tooltip: new this.LabelViewModel({
                        ergName: 'FIND_AND_CONNECT_TOOLTIP'
                    }),
                    isToolBarLink: true,
                    isFocusable: this.isFocusable,
                    isEnabled: this.isEnabled
                }),
                linkEdit: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.link.edit',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.link.edit.image',
                        source: Config.inlineImages.OBJ_EDIT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'EDIT_CONNECTED_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.pdoId() != null && this.pdoId() != this.detailViewItem.disableNavigation;
                    }),
                    onClick: (openInNewWindow) => {
                        if (openInNewWindow)
                            NavigationHelper.navigateAssociation(this.detailViewItem.listView.typeName, this.pdoId(), {
                                contextSource: this.context.isSummaryViewMode() ? 'SV' : 'DV',
                                contextTypeName: this.context.getPdTypeName(),
                                contextObject: this.context.genericObject.pdoId,
                                contextRelation: this.detailViewItem.name
                            }, openInNewWindow);
                        else
                            this.context.createContext(this, this.detailViewItem.listView, this.pdoId());
                    },
                    tooltip: new this.LabelViewModel({
                        ergName: 'EDIT_CONNECTED_TOOLTIP'
                    }),
                    isVisible: this.detailViewItem.listView.showButtonEdit,
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkDisconnect: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.link.disconnect',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.link.disconnect.image',
                        source: Config.inlineImages.OBJ_DISCONNECT,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.isEnabled() && this.pdoId() != null;
                    }),
                    onClick: this.OnDisconnect.bind(this),
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_TOOLTIP'
                    }),
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDisconnect;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                linkDelete: new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: this.detailViewItem.name + '.link.delete',
                    image: new this.ImageViewModel({
                        parentLocator: this.locator,
                        locator: this.detailViewItem.name + '.link.delete.image',
                        source: Config.inlineImages.OBJ_DELETE,
                        alternativeText: new this.LabelViewModel({
                            ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                        })
                    }),
                    isEnabled: this.defineComputed(() => {
                        return this.isEnabled() && this.pdoId() != null;
                    }),
                    tooltip: new this.LabelViewModel({
                        ergName: 'DISCONNECT_AND_DELETE_TOOLTIP'
                    }),
                    onClick: () => {
                        if (this.IsValidItemSelected()) {
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            let associationName = this.detailViewItem.listView.relationName;
                            let deletionHelper = new this.ObjectDeletionHelper({
                                pdTypeName: pdTypeName,
                                affectedObjectIds: [this.pdoId()],
                                confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                            });
                            deletionHelper.ExecuteCheck();
                        }
                    },
                    isVisible: this.defineComputed(() => {
                        return this.isEnabled() && this.detailViewItem.listView.showButtonDelete;
                    }),
                    isFocusable: this.isFocusable,
                    isToolBarLink: true
                }),
                disconnectItem: this.OnDisconnect.bind(this)
            });
            return associationBoxViewModel;
        })();
        this.control = (() => {
            return new this.AssociationBox(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        this.registerObservableValidation(this.pdoId);
        return this.jQueryControl;
    }
    public notifyDetailViewClosed(topdTypeName?: any, toPDOID?: any): void {
        RADEnvironmentProxy.getInstance().getPropertiesForDetailViewContext({
            detailViewContextID: this.context.id,
            pdoID: this.context.genericObject.pdoId,
            properties: [this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']
        }).then((properties) => {
            if (this.validateStatus(properties)) {
                let oldPdoID = this.pdoId();
                let newPdoID = properties.returnValue[this.detailViewItem.name + '.PDO_ID'];
                this.pdoId(newPdoID);
                this.objectIdentValue(properties.returnValue[this.detailViewItem.name + '.ObjectIdentValue']);
                if (oldPdoID != newPdoID) {
                    this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                }
            }
        });
    }
    /** @overrides */
    protected disposeInternal(): void {
        if (this.viewFactorySearchListView != null && !this.viewFactorySearchListView.isDisposed) {
            NavigationService.getInstance().removeViewFactory(this.viewFactorySearchListView);
        }
        super.disposeInternal();
    }
    /** @implements */
    public refresh(): JQueryPromise<boolean> {
        return this.context.refreshProperties([this.detailViewItem.name + '.ObjectIdentValue', this.detailViewItem.name + '.PDO_ID']);
    }
    public getValueForFilter(): any {
        let ret = {};
        ret[this.detailViewItem.name + '.ObjectIdentValue'] = this.objectIdentValue();
        ret[this.detailViewItem.name + '.PDO_ID'] = this.pdoId();
        return ret;
    }
    public getFilterInfo(): any {
        return {
            field: this.detailViewItem.name + '.PDO_ID',
            value: this.pdoId() || ''
        };
    }
    public resetValue(): any {
        this.OnDisconnect();
    }
    private OnDisconnect(): any {
        if (this.IsValidItemSelected()) {
            let contextId = this.context.genericObject.pdoId;
            if (+contextId > 0) {
                let disconnectionHelper = new this.ObjectDisconnectionHelper({
                    contextPdoId: this.context.genericObject.pdoId,
                    associationName: this.detailViewItem.listView.relationName,
                    pdTypeName: this.detailViewItem.listView.typeName,
                    affectedObjectIds: [this.pdoId()],
                    disconnectionCallback: this.OnDisconnectionCallback.bind(this),
                    confirmDeletionCallback: this.OnConfirmDeletionCallback.bind(this)
                });
                disconnectionHelper.ExecuteCheck();
            }
            else {
                this.pdoId(null);
                this.objectIdentValue(null);
            }
        }
    }
    private OnDisconnectionCallback(): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'disconnect', { toPdoIds: [this.pdoId()] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    RADEnvironmentProxy.getInstance().disconnect({
                        pdoID: this.context.genericObject.pdoId,
                        assoziationName: this.detailViewItem.listView.relationName,
                        topdTypeName: this.detailViewItem.listView.typeName,
                        toPDOID: this.pdoId(),
                        nestedContextName: this.context.getNestedContextPath()
                    }).then((changeObject) => {
                        if (this.validateStatus(changeObject)) {
                            this.pdoId(null);
                            this.objectIdentValue(null);
                            this.context.genericObject.isModified(true);
                            this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                            this.context.notifyFactoryRefreshed(this.detailViewItem);
                        }
                    }).always(() => {
                        Loader.getInstance().hide();
                    });
                }
            });
    }
    private OnConnection(objectIdToConnect: any): any {
        $.when(this.context.notifyBeforeUpdatedAssociation(this.detailViewItem.listView.relationName, 'connect', { toPdoIds: [objectIdToConnect] }))
            .then((doUpdateAssociation) => {
                if (doUpdateAssociation == null || doUpdateAssociation === true) {
                    Loader.getInstance().show();
                    let contextId = this.context.genericObject.pdoId;
                    if (+contextId > 0) {
                        RADEnvironmentProxy.getInstance().connect({
                            pdoID: contextId,
                            assoziationName: this.detailViewItem.listView.relationName,
                            topdTypeName: this.detailViewItem.listView.typeName,
                            toPDOID: objectIdToConnect,
                            nestedContextName: this.context.getNestedContextPath()
                        }).then((changeObject) => {
                            if (this.validateStatus(changeObject)) {
                                this.pdoId(objectIdToConnect);
                                this.objectIdentValue(changeObject.returnValue);
                                this.context.genericObject.isModified(true);
                                this.context.notifyUpdatedAssociation(this.detailViewItem.listView.relationName);
                                this.context.notifyFactoryRefreshed(this.detailViewItem);
                            }
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    } else {
                        RADEnvironmentProxy.getInstance().getObject({
                            pdTypeName: this.detailViewItem.listView.typeName,
                            pdoID: objectIdToConnect,
                            properties: ['ObjectIdentValue']
                        }).then((genericDTO) => {
                            // objectIdentValue vor pdoID setzen, da die Information sonst bei Filtern im serialisierten Filter fehlt
                            this.objectIdentValue(genericDTO.objectIdentValue);
                            this.pdoId(objectIdToConnect);
                        }).always(() => {
                            Loader.getInstance().hide();
                            this.RemoveObjectHelper();
                        });
                    }
                }
            });
    }
    private OnConfirmDeletionCallback(dialogResult: any): any {
        if (dialogResult === true) {
            if (this.IsValidItemSelected()) {
                let associationName = this.detailViewItem.listView.relationName;
                $.when(this.context.notifyBeforeUpdatedAssociation(associationName, 'disconnectAndDelete', { toPdoIds: [this.pdoId()] }))
                    .then((doUpdateAssociation) => {
                        if (doUpdateAssociation == null || doUpdateAssociation === true) {
                            Loader.getInstance().show();
                            let pdTypeName = this.detailViewItem.listView.typeName;
                            RADEnvironmentProxy.getInstance().deleteObject({
                                pdTypeName: pdTypeName,
                                pdoID: this.pdoId()
                            }).then((changeObject) => {
                                if (this.validateStatus(changeObject)) {
                                    this.pdoId(null);
                                    this.objectIdentValue(null);
                                    this.context.genericObject.isModified(true);
                                    this.context.notifyUpdatedAssociation(associationName);
                                    this.context.notifyFactoryRefreshed(this.detailViewItem);
                                    if (this._objectHelper) {
                                        this._objectHelper.ExecuteAction();
                                    }
                                }
                            }).always(() => {
                                this.RemoveObjectHelper();
                                Loader.getInstance().hide();
                            });
                        }
                    });
            }
        }
        else {
            this.RemoveObjectHelper();
        }
    }
    private IsValidItemSelected(): any {
        return this.pdoId() && this.pdoId() >= 0;
    }
    private RemoveObjectHelper(): any {
        if (this._objectHelper && !this._objectHelper.isDisposed) {
            this._objectHelper.dispose();
        }
        this._objectHelper = null;
    }
}

ComponentManager.setFactory('AssociationBox', AssociationBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('AssoziationBox', AssociationBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');